import { IconEyeExclamation, IconFileAlert, IconUserExclamation } from '@tabler/icons-react';
import { tKeys, useTranslation } from 'locales';
import { useMemo } from 'react';

import type { Menu, MenuItem } from '../types';

export function useBuildNeedsHandlingMenu(): Menu {
  const { t } = useTranslation();

  return useMemo(() => {
    const items: Array<Menu | MenuItem> = [
      {
        path: '/needs-handling/handle-clients',
        label: t(tKeys.CLIENTS),
        Icon: IconUserExclamation,
        tagLabel: 'beta',
      },
      {
        path: '/needs-handling/handle-invoices',
        label: t(tKeys.INVOICES),
        Icon: IconFileAlert,
      },
    ];

    return {
      parent: null,
      label: t(tKeys.NAV.NEEDS_HANDLING),
      Icon: IconEyeExclamation,
      path: '/needs-handling/handle-clients',
      basePath: '/needs-handling',
      items,
    };
  }, [t]);
}
